/*
 * @Description:
 * @Author: muqingkun
 * @Date: 2024-01-31 16:10:07
 * @LastEditTime: 2024-01-31 17:28:49
 * @LastEditors: muqingkun
 * @Reference:
 */
import store from '@/store'
export default (type, row) => {
  const { user } = store.state.base
  if (user.type === 2 && user.account !== row.createByCode) { // 子账号 非自己的单子  需判断操作权限
    if (user.menuId) {
      const menuId = user.menuId.split(',')
      return menuId.includes(type)
    } else {
      return false
    }
  }
  return true
}
